
import type { PropOptions } from 'vue';
import Vue from 'vue';
import WarRoomLogoIcon from './images/war-room-logo.vue.svg';
import type { IPost, IPostCategory } from '@/types/community';
import { categoryNames } from '~/components/partials/war-room/WarRoomPostForm/WarRoomPostFormCategories/constants';

export default Vue.extend({
  name: 'WarRoomCategoryBadge',
  components: {
    WarRoomLogoIcon,
  },
  props: {
    post: {
      type: Object,
      required: true,
    } as PropOptions<IPost>,
  },
  computed: {
    isOfficial(): boolean {
      return this.category.slug === categoryNames.OFFICIAL;
    },
    rootClass(): Record<string, boolean> {
      return {
        'war-room-category-badge': true,
        'war-room-category-badge--official': this.isOfficial,
      };
    },
    category(): IPostCategory {
      return this.post.category as IPostCategory;
    },
  },
});
